<section
  class="atw-page blogs-page"
  [class.is-rtl]="isAr"
  [attr.dir]="isAr ? 'rtl' : 'ltr'"
>
  <span class="shape shape-1"></span>
  <span class="shape shape-2"></span>
  <span class="dots dots-left"></span>
  <span class="dots dots-right"></span>

  <div class="atw-container">
    <!-- Hero -->
    <div class="blogs-hero">
      <div class="blogs-hero-content">
        <div class="hero-badge">
          <span>{{ 'atw.blogs.hero.badgeNumber' | transloco }}</span>
          {{ 'atw.blogs.hero.badgeTitle' | transloco }}
        </div>

        <h1>
          {{ 'atw.blogs.hero.titleLine1' | transloco }}
          <strong>{{ 'atw.blogs.hero.titleStrong' | transloco }}</strong>
        </h1>

        <p>
          {{ 'atw.blogs.hero.description' | transloco }}
        </p>

        <div class="hero-actions">
          <a class="primary-action" href="#blogs-list">
            {{ 'atw.blogs.hero.primaryBtn' | transloco }}
          </a>

          <a class="secondary-action" href="#featured-blog">
            {{ 'atw.blogs.hero.secondaryBtn' | transloco }}
            <img class="img-m" src="assets/as/23.webp" alt="featured" />
          </a>
        </div>
      </div>

      <div class="blogs-hero-visual">
        <div class="blogs-visual-card">
          <div class="blogs-visual-icon">
            <img class="img-xl" src="assets/as/23.webp" alt="blog highlight" />
          </div>

          <strong>{{ 'atw.blogs.hero.visualTitle' | transloco }}</strong>
          <p>{{ 'atw.blogs.hero.visualText' | transloco }}</p>
        </div>

        <div class="floating-card blogs-floating-card">
          <img class="img-m" src="assets/as/30.webp" alt="news" />

          <div>
            <strong>{{ 'atw.blogs.hero.floatTitle' | transloco }}</strong>
            <small>{{ 'atw.blogs.hero.floatText' | transloco }}</small>
          </div>
        </div>
      </div>
    </div>

    <!-- Featured Blog -->
    <section class="apply-section" id="featured-blog">
      <div class="section-title">
        <span>
          <b>{{ 'atw.blogs.featured.sectionNumber' | transloco }}</b>
        </span>

        <div>
          <h2>{{ 'atw.blogs.featured.title' | transloco }}</h2>
          <p>{{ 'atw.blogs.featured.subtitle' | transloco }}</p>
        </div>
      </div>

      <article
        class="apply-card featured-blog-card"
        *ngIf="featuredBlog as blog"
      >
        <div class="featured-blog-media">
          <div class="blog-category-pill">
            {{ blog.categoryLabel }}
          </div>

          <div class="featured-blog-shape">
            <img
              class="img-l"
              [src]="blog.iconImg"
              [alt]="blog.title"
              (error)="onImageError($event)"
            />
          </div>
        </div>

        <div class="featured-blog-content">
          <div
            class="blog-meta"
            *ngIf="blog.dateLabel || blog.readTimeLabel"
          >
            <span *ngIf="blog.dateLabel">{{ blog.dateLabel }}</span>
            <span *ngIf="blog.dateLabel && blog.readTimeLabel">•</span>
            <span *ngIf="blog.readTimeLabel">{{ blog.readTimeLabel }}</span>
          </div>

          <h3>{{ blog.title }}</h3>

          <p>{{ blog.excerpt }}</p>

          <div class="keyword-list" *ngIf="blog.tags.length">
            <span *ngFor="let tag of blog.tags">
              {{ tag }}
            </span>
          </div>

          <a
            class="primary-action blog-read-action"
            [routerLink]="['/blog', blog.slug]"
          >

          
            {{ 'atw.blogs.actions.readMore' | transloco }}
          </a>
        </div>
      </article>
    </section>

    <!-- Blogs List -->
    <section class="apply-section" id="blogs-list">
      <div class="section-title">
        <span>
          <b>{{ 'atw.blogs.list.sectionNumber' | transloco }}</b>
        </span>

        <div>
          <h2>{{ 'atw.blogs.list.title' | transloco }}</h2>
          <p>{{ 'atw.blogs.list.subtitle' | transloco }}</p>
        </div>
      </div>

      <div class="apply-card blogs-tools">
        <label class="blogs-search">
          <span>{{ 'atw.blogs.filters.searchLabel' | transloco }}</span>

          <input
            type="text"
            [value]="searchTerm"
            (input)="onSearch($event)"
            [placeholder]="'atw.blogs.filters.searchPlaceholder' | transloco"
          />
        </label>

        <div class="blogs-categories">
          <button
            type="button"
            *ngFor="let category of categories; trackBy: trackByCategory"
            class="blog-filter-btn"
            [class.active]="activeCategory === category.id"
            (click)="setCategory(category.id)"
          >
            {{ category.labelKey | transloco }}
          </button>
        </div>
      </div>

      <!-- Loading -->
      <div class="apply-card blogs-empty" *ngIf="loadingBlogs">
        <div>
          <img class="img-m" src="assets/as/23.webp" alt="loading" />
        </div>

        <h3>
          {{ isAr ? 'جاري تحميل المقالات...' : 'Loading blogs...' }}
        </h3>
      </div>

      <!-- Error -->
      <div class="apply-card blogs-empty" *ngIf="!loadingBlogs && blogsError">
        <div>
          <img class="img-m" src="assets/as/2.webp" alt="error" />
        </div>

        <h3>{{ blogsError }}</h3>

        <button type="button" class="primary-action" (click)="loadBlogs()">
          <span>↺</span>
          {{ isAr ? 'إعادة المحاولة' : 'Try again' }}
        </button>
      </div>

      <!-- Blogs Grid -->
      <div
        class="blogs-grid"
        *ngIf="!loadingBlogs && !blogsError && filteredBlogs.length; else emptyBlogs"
      >
        <article
          class="apply-card blog-card"
          *ngFor="let blog of filteredBlogs; trackBy: trackByBlog"
        >
          <div class="blog-card-top">
            <div class="blog-icon">
              <img
                class="img-m"
                [src]="blog.iconImg"
                [alt]="blog.title"
                (error)="onImageError($event)"
              />
            </div>

            <div class="blog-category-pill">
              {{ blog.categoryLabel }}
            </div>
          </div>

          <div
            class="blog-meta"
            *ngIf="blog.dateLabel || blog.readTimeLabel"
          >
            <span *ngIf="blog.dateLabel">{{ blog.dateLabel }}</span>
            <span *ngIf="blog.dateLabel && blog.readTimeLabel">•</span>
            <span *ngIf="blog.readTimeLabel">{{ blog.readTimeLabel }}</span>
          </div>

          <h3>{{ blog.title }}</h3>

          <p>{{ blog.excerpt }}</p>

          <div class="keyword-list blog-tags" *ngIf="blog.tags.length">
            <span *ngFor="let tag of blog.tags">
              {{ tag }}
            </span>
          </div>

          <a
            class="secondary-action blog-card-action"
            [routerLink]="['/blog', blog.slug]"
          >
            {{ 'atw.blogs.actions.readArticle' | transloco }}
          </a>
        </article>
      </div>

      <!-- Empty -->
      <ng-template #emptyBlogs>
        <div
          class="apply-card blogs-empty"
          *ngIf="!loadingBlogs && !blogsError"
        >
          <div>
            <img class="img-m" src="assets/as/2.webp" alt="search" />
          </div>

          <h3>{{ 'atw.blogs.empty.title' | transloco }}</h3>
          <p>{{ 'atw.blogs.empty.text' | transloco }}</p>

          <button type="button" class="primary-action" (click)="resetFilters()">
            <span>↺</span>
            {{ 'atw.blogs.empty.btn' | transloco }}
          </button>
        </div>
      </ng-template>
    </section>

    <!-- CTA -->
    <section class="apply-section">
      <div class="apply-card blogs-cta">
        <div>
          <span>{{ 'atw.blogs.cta.badge' | transloco }}</span>
          <h2>{{ 'atw.blogs.cta.title' | transloco }}</h2>
          <p>{{ 'atw.blogs.cta.text' | transloco }}</p>
        </div>

        <a class="primary-action" routerLink="/apply">

          {{ 'atw.blogs.cta.btn' | transloco }}
        </a>
      </div>
    </section>
  </div>
</section>
